<template>
  <div
    class="inline-flex items-center rounded-full border font-semibold"
    style="gap: 3px; padding: 4px 8px; font-size: 11.5px; color: #f1f1f1"
    :style="{
      backgroundColor: backgroundColor,
      borderColor: borderColor
    }"
  >
    <component :is="icon" size="15" style="margin-left: -1px" />
    <div class="capitalize" style="line-height: 1.2">
      {{ phrase }}
    </div>
  </div>
</template>

<script>
import IconDiamond from "@/components/Icon/IconDiamond.vue";
import IconArrowNorth from "@/components/Icon/IconArrowNorth.vue";
import IconArrowNortheast from "@/components/Icon/IconArrowNortheast.vue";
import IconArrowEast from "@/components/Icon/IconArrowEast.vue";
import IconArrowSoutheast from "@/components/Icon/IconArrowSoutheast.vue";

export default {
  name: "TwScoreBadge",
  props: {
    score: {
      type: [ String, Number ],
      default: ""
    }
  },
  computed: {
    numericScore() {
      return parseFloat(this.score);
    },
    phrase() {
      if (this.numericScore >= 93) {
        return "Diamond In The Rough";
      } else if (this.numericScore >= 80) {
        return "Great Deal";
      } else if (this.numericScore >= 60) {
        return "Good Deal";
      } else if (this.numericScore >= 40) {
        return "Fair Deal";
      } else {
        return "Poor Deal";
      }
    },
    color() {
      if (this.numericScore >= 93) {
        return "#d1eeff";
      } else if (this.numericScore >= 80) {
        return "#43e46c";
      } else if (this.numericScore >= 60) {
        return "#28ae60";
      } else if (this.numericScore >= 40) {
        return "#F2C037";
      } else {
        return "#EF4444";
      }
    },
    backgroundColor() {
      return this.blendColor(this.color, 0.6);
    },
    borderColor() {
      return this.blendColor(this.color, 0.8);
    },
    icon() {
      if (this.numericScore >= 93) {
        return IconDiamond;
      } else if (this.numericScore >= 80) {
        return IconArrowNorth;
      } else if (this.numericScore >= 60) {
        return IconArrowNortheast;
      } else if (this.numericScore >= 40) {
        return IconArrowEast;
      } else {
        return IconArrowSoutheast;
      }
    }
  },
  methods: {
    blendColor(hexColor, alpha) {
      const hex = hexColor.replace("#", "");
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);

      // Blend with dark background (e.g., #1a1a1a)
      const bgR = 26,
        bgG = 26,
        bgB = 26;

      const blendedR = Math.round(bgR + (r - bgR) * alpha);
      const blendedG = Math.round(bgG + (g - bgG) * alpha);
      const blendedB = Math.round(bgB + (b - bgB) * alpha);

      return `#${blendedR.toString(16).padStart(2, "0")}${blendedG
        .toString(16)
        .padStart(2, "0")}${blendedB.toString(16).padStart(2, "0")}`;
    }
  }
}
</script>
